import { Link } from 'react-router-dom';
import { Plus, Minus, Crosshair, X, ArrowRight, MapPin } from 'lucide-react';

const glass = {
  background: 'rgba(5,8,10,0.62)',
  border: '1px solid rgba(255,255,255,0.1)',
  backdropFilter: 'blur(16px)',
  WebkitBackdropFilter: 'blur(16px)',
  color: '#e9f3dd',
};

const fmtPrice = (l) => {
  if (!l.price) return 'Prezzo su richiesta';
  const p = `€ ${new Intl.NumberFormat('it-IT').format(l.price)}`;
  return l.listing_type === 'rent' ? `${p}${l.rental_period === 'monthly' ? '/mese' : '/anno'}` : p;
};

function SelectedCard({ l, onClose }) {
  return (
    <div className="absolute left-3 right-3 bottom-3 sm:left-4 sm:right-auto sm:bottom-4 sm:w-[340px] z-20 rounded-2xl p-4 globe-card-in"
         style={glass} data-testid="globe-selected-card">
      <button onClick={onClose} className="absolute top-3 right-3 text-white/60 hover:text-white transition-colors"
              data-testid="globe-selected-close" aria-label="Chiudi"><X size={15}/></button>
      <div className="text-[9px] uppercase tracking-[0.28em] font-bold" style={{ color: l.listing_type === 'rent' ? '#8dd8ff' : 'rgb(180,255,0)' }}>
        {l.listing_type === 'rent' ? 'Affitto' : 'Vendita'}
      </div>
      <div className="mt-1.5 font-display text-lg leading-tight pr-6 text-white" data-testid="globe-selected-title">{l.title}</div>
      <div className="mt-1.5 flex items-center gap-1.5 text-xs text-white/60">
        <MapPin size={11}/> {[l.location?.comune, l.location?.region].filter(Boolean).join(', ') || 'Italia'}
        {l.area_hectares ? <span>· {l.area_hectares} ha</span> : null}
      </div>
      <div className="mt-3 flex items-center justify-between gap-3">
        <div className="font-display text-xl text-white" data-testid="globe-selected-price">{fmtPrice(l)}</div>
        <Link to={`/terreno/${l.listing_id}`} data-testid="globe-selected-open"
              className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full text-xs font-semibold transition-transform hover:scale-[1.04]"
              style={{ background: 'rgb(180,255,0)', color: '#0A0D10' }}>
          Apri scheda <ArrowRight size={13}/>
        </Link>
      </div>
    </div>
  );
}

function CtrlBtn({ onClick, testId, label, children }) {
  return (
    <button onClick={onClick} data-testid={testId} aria-label={label} title={label}
            className="w-9 h-9 rounded-full flex items-center justify-center transition-[background-color,transform] hover:scale-105 hover:bg-white/15"
            style={glass}>
      {children}
    </button>
  );
}

export default function GlobeOverlay({ ready, count, hudLabel, pickMode, selected, onCloseSelected, onZoomIn, onZoomOut, onReset }) {
  return (
    <>
      {!ready && (
        <div className="absolute inset-0 z-20 flex items-center justify-center pointer-events-none">
          <div className="flex flex-col items-center gap-3">
            <div className="relative">
              <div className="w-12 h-12 rounded-full border-2 border-white/10"/>
              <div className="absolute inset-0 w-12 h-12 rounded-full border-2 border-transparent animate-spin" style={{ borderTopColor: 'rgb(180,255,0)' }}/>
            </div>
            <div className="text-[9px] uppercase tracking-[0.3em] font-bold text-white/60">Caricamento globo…</div>
          </div>
        </div>
      )}

      {count !== null && (
        <div className="absolute top-4 left-4 z-10 pointer-events-none">
          <div className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-[10px] uppercase tracking-[0.26em] font-bold" style={glass}
               data-testid="globe-hud-count">
            <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: 'rgb(180,255,0)' }}/>
            {count} {hudLabel}
          </div>
        </div>
      )}

      <div className="absolute top-4 right-4 z-10 flex flex-col gap-2">
        <CtrlBtn onClick={onZoomIn} testId="globe-zoom-in" label="Avvicina"><Plus size={15}/></CtrlBtn>
        <CtrlBtn onClick={onZoomOut} testId="globe-zoom-out" label="Allontana"><Minus size={15}/></CtrlBtn>
        <CtrlBtn onClick={onReset} testId="globe-reset" label="Ricentra"><Crosshair size={15}/></CtrlBtn>
      </div>

      {selected && <SelectedCard l={selected} onClose={onCloseSelected}/>}

      <div className="absolute bottom-3 right-4 z-10 pointer-events-none text-right">
        <div className="hidden sm:block text-[10px] uppercase tracking-[0.24em] font-bold" style={{ color: 'rgba(240,245,230,0.55)' }}>
          {pickMode ? 'Clicca sul globo per scegliere il punto' : 'Trascina per ruotare · Scroll per zoom'}
        </div>
        <div className="text-[9px] mt-0.5" style={{ color: 'rgba(240,245,230,0.35)' }}>Imagery © NASA · Esri World Imagery</div>
      </div>
    </>
  );
}
